import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'గేమ్‌జోప్‌లో డౌన్‌లోడ్ చేయకుండా ఆడటానికి ఫ్రీ ఆన్‌లైన్ గేమ్స్ | Gamezop',
  desc: 'Gamezopలో డౌన్‌లోడ్ చేయకుండా ఉచిత ఆన్‌లైన్ గేమ్స్ ఆడండి. యాక్షన్, అడ్వెంచర్, ఆర్కేడ్, పజిల్, రేసింగ్ మరియు మరిన్ని విభాగాల్లో 200+ ఉచిత గేమ్స్ అందుబాటులో ఉన్నాయి. ఇప్పుడే ఆడండి!',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'గేమ్‌జోప్‌లో డౌన్‌లోడ్ చేయకుండా ఆడటానికి ఫ్రీ ఆన్‌లైన్ గేమ్స్',
    body: {
      text: [
        `Gamezop లో మీరు డౌన్‌లోడ్ చేయకుండానే ఉచితంగా ఆన్‌లైన్ గేమ్స్ ఆడండి!
        మీరు ఇష్టపడే గేమ్‌ను ఎంచుకొని కొన్ని సెకన్లలో ఆడడం ప్రారంభించండి. మా వద్ద యాక్షన్, అడ్వెంచర్, ఆర్కేడ్, పజిల్, రేసింగ్ వంటి విభాగాల్లో 200+ కంటే ఎక్కువ ఉచిత గేమ్స్ ఉన్నాయి. మీరు మొబైల్, PC లేదా iOS లో ఆడాలని అనుకుంటున్నా, Gamezop మీ కోసం ఉత్తమ గేమ్స్ అందిస్తుంది.`,
        `మీకు బోర్ గా అనిపిస్తే, Gamezop మీ కోసం ఎన్నో రకాల వినోద గేమ్స్ కలిగి ఉంది. Kingdom Fight, City Cricket, Fruity Fiesta లాంటి ఉత్కంఠభరితమైన గేమ్స్ ఆడండి. మా గేమ్స్ పిల్లలు, పెద్దలు, వృద్ధులు అందరికీ అనుకూలంగా ఉంటాయి.`,
        `ఈ గేమ్స్ ఆడటానికి ఖరీదైన పరికరాలు అవసరం లేదు. డౌన్‌లోడ్ లేకుండా బ్రౌజర్ & ఇంటర్నెట్ ద్వారా ఆడవచ్చు. డెస్క్‌టాప్, ల్యాప్‌టాప్, క్రోమ్‌బుక్, స్మార్ట్‌ఫోన్, టాబ్లెట్ వంటి అన్ని పరికరాల్లో ఈ గేమ్స్ పని చేస్తాయి.`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: 'ఉత్తమ ఉచిత ఆన్‌లైన్ గేమ్స్ ఏమిటి?',
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'ఫ్రెండ్స్‌తో ఆడేందుకు ఉచిత ఆన్‌లైన్ గేమ్స్ ఏమిటి?',
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'అత్యంత ప్రజాదరణ పొందిన ఆన్‌లైన్ గేమ్స్ జానర్‌లు ఏమిటి?',
    body: {
      text: [],
      list: [
        {
          name: 'క్రేజీ గేమ్స్',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'బోర్డ్ గేమ్స్',
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'అడ్వెంచర్ గేమ్స్',
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'పజిల్ గేమ్స్',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'షూటింగ్ గేమ్స్',
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Gamezop ఏమిటి?',
    body: {
      text: [
        `Gamezop అనేది ప్లగ్-అండ్-ప్లే గేమింగ్ ప్లాట్‌ఫాం, ఇది యాప్‌లు మరియు వెబ్‌సైట్‌లలో క్యాజువల్ గేమ్స్‌ను సులభంగా ఇంటిగ్రేట్ చేయడం ద్వారా యూజర్ ఎంగేజ్‌మెంట్‌ను పెంచుతుంది. గేమింగ్‌కు పైన, Gamezop అనేక ప్రత్యేకమైన ప్లాట్‌ఫారమ్‌లను నిర్వహిస్తుంది: Quizzop ఇంటరాక్టివ్ క్విజ్‌లు మరియు ట్రివియా కోసం, Astrozop జ్యోతిష శాస్త్ర సమాచారాలు మరియు ఫలితాల కోసం, Criczop లైవ్ క్రికెట్ స్కోర్లు మరియు అప్‌డేట్‌ల కోసం, మరియు Feedzop ఎంపిక చేసిన వార్తా కంటెంట్‌ను అందించడానికి. ఈ అన్ని ప్లాట్‌ఫారమ్‌లు కలిపి విభిన్న ప్రేక్షకుల ఆసక్తులకు అనుగుణమైన కంటెంట్ సొల్యూషన్‌ల విస్తృత శ్రేణిని అందిస్తాయి.`,
        `8,000 కంటే ఎక్కువ ఇంటిగ్రేషన్లు, 70 కంటే ఎక్కువ దేశాలు, మరియు Amazon, Samsung Internet, Snap, Tata Play, AccuWeather, మరియు Paytm వంటి గ్లోబల్ బ్రాండ్‌లు Gamezop మరియు అనుబంధ ప్లాట్‌ఫారమ్‌లను విశ్వసిస్తున్నాయి. ఈ సొల్యూషన్‌లు యూజర్ ఎంగేజ్‌మెంట్‌ను పెంచడమే కాకుండా, కొత్త అడ్వర్టైజింగ్ రెవెన్యూ అవకాశాలను తెరవడానికి సహాయపడతాయి. ఇంటిగ్రేషన్ ప్రక్రియ సులభమైనది, కేవలం 30 నిమిషాల్లో పూర్తి చేయవచ్చు, మరియు యాప్‌లు మరియు వెబ్‌సైట్‌లు గేమ్స్, క్విజ్‌లు, జ్యోతిషం, క్రికెట్ మరియు వార్తలతో ఆసక్తికరమైన కంటెంట్‌ను అందించగలవు.`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'తరచుగా అడిగే ప్రశ్నలు',
  faqs: [
    {
      tag: 'h3',
      title: 'ఇన్‌స్టాల్ చేయకుండా నేను ఉచిత గేమ్స్ ఆడగలనా?',
      body: ['అవును, మీరు ఇన్‌స్టాల్ చేయకుండా లేదా డౌన్‌లోడ్ చేయకుండా ఉచిత గేమ్స్ ఆడవచ్చు.'],
    },
    {
      tag: 'h3',
      title: 'ఆడేందుకు నేను సైన్ అప్ చేయాలా?',
      body: [
        'లేదు, మీరు Gamezop.comలో గేమ్స్ ఆడేందుకు సైన్ అప్ చేయాల్సిన అవసరం లేదు. మీరు రిజిస్ట్రేషన్ లేకుండా వెంటనే ఆడడం ప్రారంభించవచ్చు.',
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/te',
      },
    },
    {
      tag: 'h3',
      title: 'ఆన్‌లైన్ గేమ్స్ ఆడటం సురక్షితమేనా?',
      body: [
        'అవును, Gamezop వంటి నమ్మకమైన ప్లాట్‌ఫామ్‌లపై ఆన్‌లైన్ గేమ్స్ ఆడటం సురక్షితం. మా గేమ్స్ డౌన్‌లోడ్ అవసరం లేకుండా పనిచేస్తాయి, ఇది మాల్వేర్ ప్రమాదాలను తగ్గిస్తుంది. మేము యూజర్ భద్రతపై దృష్టి సారించి, మీ ప్రైవసీ లేదా డివైజ్',
      ],
    },
    {
      tag: 'h3',
      title: 'ఉచిత గేమ్స్ నిజంగానే ఉచితంనా?',
      body: [
        'అవును, ఉచిత గేమ్స్ Gamezopలో నిజంగానే ఉచితంగా ఆడవచ్చు. అయితే, ఈ గేమ్స్ ప్లాట్‌ఫారమ్‌ను మద్దతు చేయడానికి యాడ్స్ చూపించవచ్చు.',
      ],
    },
    {
      tag: 'h3',
      title: 'వృద్ధుల కోసం ఆన్‌లైన్‌లో ఉచిత గేమ్స్ ఉన్నాయా?',
      body: [
        'అవును, మా వద్ద వృద్ధుల కోసం ఉచిత గేమ్స్ ఉన్నాయి, మీరు ఆన్‌లైన్‌లో ఆడవచ్చు. అందులో Sudoku Classic, Solitaire Gold, Chess Grandmaster మరియు మరిన్ని ఉన్నాయి.',
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
